<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs12>
        <chart-bar-horizontal :chart-data="chartData" :options="chartOptions"></chart-bar-horizontal>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ChartBarHorizontal from '@/components/ChartBarHorizontal.js'

import ApiRequests from '@/api/ApiRequests'

export default {
  components: {
    ChartBarHorizontal
  },

  data () {
    return {
      chartData: {},
      chartOptions: {
        maintainAspectRatio: false
      },
      totalEvents: 0,
      totalGroups: 0,
      totalUsers: 0
    }
  },

  created () {
    this.getData()
  },

  computed: {
    ...mapGetters([
      'selectedSite'
    ])
  },

  methods: {
    getData: function () {
      this.loading = true
      var params = {}
      params.site = this.selectedSite._id
      var userParams = {}
      userParams.resource = this.selectedSite._id

      Promise.all([
        ApiRequests.eventQuery(params).then(r => {
          this.totalEvents = parseInt(r.headers['x-total-count'])
        }),
        ApiRequests.groupQuery(params).then(r => {
          this.totalGroups = parseInt(r.headers['x-total-count'])
        }),
        ApiRequests.userQuery(userParams).then(r => {
          this.totalUsers = parseInt(r.headers['x-total-count'])
          console.log(this.totalUsers)
        })
      ]).then(() => {
        this.fillData()
      })
    },

    fillData: function () {
      var data = []
      var labels = []

      data.push({
        x: this.totalEvents,
        y: 0
      })
      labels.push('events')

      data.push({
        x: this.totalGroups,
        y: 1
      })
      labels.push('groups')

      data.push({
        x: this.totalUsers,
        y: 1
      })
      labels.push('users')

      this.chartOptions = {}
      this.chartOptions = {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                callback: function (value, index, values) {
                  if (value % 1 === 0) { return value }
                },
                suggestedMin: 0
              }
            }
          ],
          yAxes: [
            {}
          ]
        }
      }
      this.chartData = {
        labels: labels,
        datasets: [
          {
            label: 'Total',
            borderColor: 'rgba(118, 149, 185, 1.0)',
            borderWidth: 2,
            backgroundColor: 'rgba(118, 149, 185, 0.5)',
            data: data
          }
        ]
      }
    }
  }
}
</script>
